import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import PersonalData from './PersonalData';

const GetUserInfoQuery = gql`
  query PersonalDataUserQuery {
    countries {
      id
      parentCountryId
      name
      title
      details
      slug
      VATrate
      currency
      language
      code
      flag
      weightUnit
      business {
        id
        country
      }
      states {
        id
        name
        title
        vatRate
      }
    }
    userInfo {
      id
      
      email
      phone
      
      receiveNewsletter
      
      companyInformation
      companyName
      companyRegistrationNumber
      companyVatNumber
      companyVatValidationDate

      invoiceFirstName
      invoiceLastName
      
      invoiceStreet
      invoiceHouseNumber
      invoiceAddressLine1
      invoiceAddressLine2
      invoiceZip
      invoiceCity
      invoiceCountyState
      invoiceCountry

      anotherDeliveryAddress
      deliveryPhone
      deliveryStreet
      deliveryHouseNumber
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryZip
      deliveryCity
      deliveryCountyState
      deliveryCountry

      saleTaxCertificate
    }
  }
`;

const CreateOrderMutation = gql`
  mutation createOrder($order: OrderInput!) {
    createOrder(order: $order) {
      order {
        id
        orderNumber
        email
        createdAt

        subTotal
        total
        paymentTotal
        deliveryTotal
        deliveryInsuranceTotal
        grandTotal

        orderedItems {
          id

          title
          name
          description
          definition
          price
          deliveryPriceAddition

          weight
          VATrate
          quantity
          ean
          sku
        }
      }
      maxAvailableStock {
        productVariantId
        inStock
      }
    }
  }
`;

const CreatePaymentMutation = gql`
  mutation createPayment($orderNumber: String!, $language: String!) {
    createPayment(payment: { orderNumber: $orderNumber, language: $language }) {
      gatewayUrl
      error
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(GetUserInfoQuery, { options: { fetchPolicy: 'network-only' } }),
  graphql<any, any>(CreateOrderMutation, {
    name: 'createOrder'
  }),
  graphql<any, any>(CreatePaymentMutation, {
    name: 'createPayment'
  })
)(PersonalData);



// WEBPACK FOOTER //
// ./src/pages/PersonalData/index.tsx